import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { DEFAULT_PAGE_SIZE } from './config/Pagination'

export const getUnitChecklist = async (id: string) =>
  AxiosInstance.get(
    `${Config.core.checklist}?unitId.equals=${id}&sort=idCheckList,desc&page=0&size=${DEFAULT_PAGE_SIZE}`
  )

export const getContractChecklist = async (id: string) =>
  AxiosInstance.get(
    `${Config.core.checklist}?contractId.equals=${id}&sort=idCheckList,desc&page=0&size=${DEFAULT_PAGE_SIZE}`
  )

export const printChecklist = async (id: string) =>
  AxiosInstance.get(`${Config.core.checklist}/print/${id}`, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'checklist' + id + '.pdf') //or any other extension
    document.body.appendChild(link)
    link.click()
  })
